"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getLayerHeight = exports.getLayerHeight = function getLayerHeight(buttonWidth) {
  return buttonWidth * 0.1;
};